import { Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useCreateRuleFormContext } from 'context/FormContext';
import { RuleReportGenerations, RuleTriggers } from 'models/rules';
import { HeartRhythmTransitionFields } from './HeartRhythmTransitionFields';
import { HeartRhythmMeasurementFields } from './HeartRhythmMeasurement/HeartRhythmMeasurementFields';
import { PhysiologicalParameterThresholdFields } from './PhysiologicalParameterThresholdFields';
import { PhysiologicalParameterChangeFields } from './PhysiologicalParameterChangeFields';
import { PhysiologicalParameterMissingFields } from './PhysiologicalParameterMissingFields';
import { HeartRhythmNoteFields } from './HeartRhythmNoteFields';
import { TimeSincePrescriptionFields } from './TimeSincePrescriptionFields';
import { ReportGeneratedFields } from './ReportGeneratedFields';

export const DefineConditionsFields = () => {
  const { t } = useTranslation();
  const {
    values: { trigger },
  } = useCreateRuleFormContext();

  return (
    <>
      <Title order={4} mb={-10}>
        {t('define_conditions_label')}
      </Title>
      {trigger === RuleTriggers.heartRhythmTransition && <HeartRhythmTransitionFields />}
      {trigger === RuleTriggers.heartRhythmMeasurement && <HeartRhythmMeasurementFields />}
      {trigger === RuleTriggers.physiologicalParameterChange && <PhysiologicalParameterChangeFields />}
      {trigger === RuleTriggers.physiologicalParameterThreshold && <PhysiologicalParameterThresholdFields />}
      {trigger === RuleTriggers.physiologicalParameterMissing && <PhysiologicalParameterMissingFields />}
      {trigger === RuleTriggers.heartRhythmNote && <HeartRhythmNoteFields />}
      {[RuleTriggers.reportGenerated, ...Object.values(RuleReportGenerations)].includes(trigger) && (
        <ReportGeneratedFields />
      )}
      {trigger === RuleTriggers.timeSincePrescription && <TimeSincePrescriptionFields />}
    </>
  );
};
